import http from 'hub-http/clients/apiClient';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
export default class ConnectedFormsApi {}
ConnectedFormsApi.getConnectedForms = makeSimpleQuickFetchWrapper('get-connected-forms', searchString => http.get('forms/v2/forms', {
  query: {
    clienttimeout: 30000,
    limit: 500,
    offset: 0,
    formType: 'HUBSPOT',
    property: ['formFieldGroups', 'name', 'guid', 'metaData'],
    name__contains: searchString
  }
}));